// extracted by mini-css-extract-plugin
export default {"modal":"modal-nw3mUwH","small":"small-L5gK9x4","medium":"medium-UCVrmOJ","large":"large-CDzLP4Q","modal-content":"modal-content-yACwWY6"};